"use client";

import Image from "next/image";
import { Heading } from "@/components/ui/typography";

const cards = [
  {
    id: 1,
    title: "Business Registration Renewal",
    desc: "Issued annually by the Inland Revenue Department. Maintains your company's legal operating status.",
    icon: "/registration-icon.svg",
    size: 65,
  },
  {
    id: 2,
    title: "Annual Return Filing",
    desc: "Submitted to Companies Registry. Confirms directors, shareholders, address, and structure updates. Late filing results in escalating penalties.",
    icon: "/switch-icon-4.svg",
    size: 65,
  },
  {
    id: 3,
    title: "Mandatory Audit Preparation",
    desc: "Your accounts must be prepared according to Hong Kong accounting standards and audited before submission with tax filings.",
    icon: "/audit-icon.svg",
    size: 65,
  },
  {
    id: 4,
    title: "Profits Tax Return Submission",
    desc: "Issued by IRD. Must be submitted together with audited accounts, supporting schedules, and offshore claim documentation (if applicable).",
    icon: "/switch-icon-2.svg",
    size: 65,
  },
];

export default function SwitchToMuteTaxes({ heading = "HK Company Annual Filing Requirements Explained" }: { heading?: string } = {}) {
  return (
    <section className="bg-black md:py-[60px] py-[30px] px-4">
      <div className="max-w-[1200px] mx-auto flex flex-col gap-10">
        {/* TITLE */}
        <div>
          <Heading as="h2" variant="sectionCentered">
            {heading}
          </Heading>
          <p className="max-w-[716px] mt-[24px] mx-auto text-center text-white/60 text-[18px] font-medium">
            If you&apos;re managing a company from abroad, the compliance
            schedule can feel unclear. Here&apos;s exactly what a Hong Kong
            company must file each year.
          </p>
        </div>

        {/* GRID (50% / 50%) */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {cards.map((card) => (
            <div
              key={card.id}
              className="bg-[#0f1218] border border-white/10 rounded-2xl p-6 md:px-10 md:py-[24px] flex gap-6 items-start"
            >
              {/* ICON */}
              <div
                className="relative flex-shrink-0"
                style={{
                  width: card.size,
                  height: card.size,
                }}
              >
                <Image
                  src={card.icon}
                  alt={card.title}
                  fill
                  className="object-contain [filter:brightness(0)_invert(1)]"
                />
              </div>

              {/* CONTENT */}
              <div className="flex flex-col gap-2">
                <h3 className="text-white text-[18px] md:text-[20px] font-semibold leading-[120%]">
                  {card.title}
                </h3>
                <p className="text-white/60 text-[14px] md:text-[16px] leading-[150%]">
                  {card.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
